.tooltip-button-wrapper {
  display: inline-block;
  line-height: 0;
}

.tippy-box {
  --btn--z-index: 100;
  position: relative;
  background-color: var(--fdt-semantic-color-foreground-default);
  color: var(--fdt-semantic-color-foreground-inverted);
  font-family: var(--fdt-semantic-typography-label-tiny-fontfamily);
  font-size: var(--fdt-semantic-typography-label-tiny-fontsize);
  line-height: var(--fdt-semantic-typography-label-tiny-lineheight);
  letter-spacing: var(--fdt-semantic-typography-label-tiny-letterspacing);
  font-weight: var(--fdt-semantic-typography-label-tiny-fontweight);
  margin-block-start: var(--tooltip-box--mbs);
  margin-block-end: var(--tooltip-box--mbe);
  margin-inline-start: var(--tooltip-box--mis);
  margin-inline-end: var(--tooltip-box--mie);
}
.tippy-box.has-close .tippy-content {
  padding-inline-end: calc(var(--fdt-core-spacing-2) + var(--fdt-core-size-icon-tiny));
}
.tippy-box[data-theme=action-menu] {
  background-color: white;
  box-shadow: var(--core-shadow-2);
}
.tippy-box[data-theme=action-menu] .tippy-content {
  padding: 0;
}
.tippy-box[data-theme=action-menu] .tippy-arrow {
  display: none;
}

.tippy-content {
  padding: var(--fdt-core-spacing-2);
}

.tippy-arrow {
  color: var(--fdt-semantic-color-foreground-default);
}

.tippy-inner {
  position: relative;
  display: block;
}

.tippy-close {
  --btn--padding: 0;
  position: absolute;
  top: -0.1rem;
  right: 0;
  width: var(--fdt-core-size-icon-tiny);
  height: var(--fdt-core-size-icon-tiny);
  font-size: var(--fdt-core-typography-size-small, 0.875rem);
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tippy-inner.has-close {
  padding-inline-end: calc(var(--fdt-core-spacing-2) + var(--fdt-core-size-icon-tiny));
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */